import { RbacAction, RbacPermission, RbacResource } from '~/types/Rbac';

/**
 * Keying by `RbacResource` (rather than a plain array) makes this
 * exhaustive: TypeScript errors if a resource is added to the union here
 * and missing from `Rbac.d.ts`, or vice versa.
 */
const RBAC_RESOURCE_MAP: Record<RbacResource, true> = {
  ai_drafting_tools: true,
  audit_logs: true,
  clause_library: true,
  clause_library_manage: true,
  clause_quick_ai: true,
  clause_samples: true,
  conversational_ai: true,
  data_fields: true,
  deleted_documents: true,
  departments: true,
  document_x_ray: true,
  documents: true,
  documents_dashboard: true,
  documents_metadata_bulk_upload: true,
  email_intake: true,
  entities: true,
  entity_groups: true,
  entity_types: true,
  field_manager: true,
  folder_access: true,
  integrations: true,
  restoration_hub: true,
  roles: true,
  root_folder_access_settings: true,
  sso: true,
  users: true,
  workflow_templates: true,
  workflow_tickets: true,
  workflows_dashboard: true,
};

export const RBAC_ACTIONS: RbacAction[] = ['view', 'edit'];

/** Every `{ resourceId, resourceType }` pair the app can ever check. */
export const ALL_RBAC_PERMISSIONS: RbacPermission[] = (
  Object.keys(RBAC_RESOURCE_MAP) as RbacResource[]
).flatMap((resourceId) =>
  RBAC_ACTIONS.map((resourceType) => ({ resourceId, resourceType })),
);
